/*
 * Dev-only demo data. Activated with `?demo=1` URL flag. Bypasses backend so
 * Phase 1 can be visually verified without running Laravel. Removed/replaced
 * by Phase 7's full LocalBackend + seed-demo flow.
 */

import type { EpisodeBundle } from '@/services/episodeApi';

export function isDemoMode(): boolean {
  if (!import.meta.env.DEV) return false;
  return new URLSearchParams(window.location.search).get('demo') === '1';
}

export function buildDemoBundle(uuid: string): EpisodeBundle {
  const now = Date.now();
  return {
    episode: {
      uuid,
      title: 'Demo Episode — Aida and the Honey Cat',
      script: 'Once upon a time…',
      styleSettings: {
        presetId: null,
        aspectRatio: '16:9',
        imageQuality: '2K',
        culturalGuidelines: true,
        activeImageTemplateId: null,
        activeVideoTemplateId: null,
      },
    },
    characters: [
      {
        id: 'c-1',
        name: 'Aida',
        description: 'A bright-eyed seven-year-old.',
        type: 'character',
        imagePath: '',
      },
      {
        id: 'c-2',
        name: 'Honey Cat',
        description: 'A small ginger cat who follows Aida everywhere.',
        type: 'character',
        imagePath: '',
      },
      {
        id: 'c-3',
        name: 'Garden',
        description: 'A flower garden in summer light.',
        type: 'location',
        imagePath: '',
      },
    ],
    scenes: Array.from({ length: 6 }).map((_, i) => ({
      id: `s-${i + 1}`,
      episodeUuid: uuid,
      order: i + 1,
      prompt:
        i === 0
          ? 'Aida steps into the garden. Honey Cat watches from the bench.'
          : i === 1
            ? 'Aida picks a sunflower and laughs.'
            : i === 2
              ? 'Honey Cat chases a butterfly through the roses.'
              : '',
      references: { sceneIds: [], castIds: [] },
      imageIds: [],
      videoIds: [],
      heroImageId: null,
      status: 'empty' as const,
      version: 1,
      createdAt: now - (6 - i) * 60_000,
      updatedAt: now - (6 - i) * 60_000,
      deletedAt: null,
    })),
    images: [],
    videos: [],
  };
}
